import { render } from "./ExamDetailPage.vue?vue&type=template&id=10cfa31e&scoped=true"
import script from "./ExamDetailPage.vue?vue&type=script&lang=js"
export * from "./ExamDetailPage.vue?vue&type=script&lang=js"

import "./ExamDetailPage.vue?vue&type=style&index=0&id=10cfa31e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cfa31e"]])

export default __exports__